import {useFormContext} from '@yandex-delivery/form'
import {applySpec, flow, get} from '@yandex-delivery/utils'
import {useCallback, useState} from 'react'

import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import type {Props as CardProps} from './Card/types'
import {segments} from './consts'

function getSegmentNameByProductName(productName?: string) {
  return productName && productName in segments ? segments[productName] : 'other'
}

const toBody: CardProps['getBody'] = applySpec({
  segment: flow(get('destinationPoints[0].parcels[0].products[0].name'), getSegmentNameByProductName),
})

export function usePaymentMethod() {
  const isBusiness = useFormContext().watch('isBusiness')
  const [isBannerVisible, setIsBannerVisible] = useState(false)
  const handleReachGoal = useFormUserEventHandler()

  const toggleBannerVisibilityHandler = useCallback(() => {
    setIsBannerVisible(prev => !prev)
    handleReachGoal(OrderEventGoal.B2BOfferClick)
  }, [handleReachGoal])

  function bannerActiveButtonClickHandler() {
    handleReachGoal(OrderEventGoal.BannerRegistrationButtonClick)
  }

  return {
    isBusiness,
    isBannerVisible,
    toggleBannerVisibilityHandler,
    toBody,
    bannerActiveButtonClickHandler,
  } as const
}
